import Roles from '@/constants/Roles';
import { signOut, useSession } from 'next-auth/react';
import { useMemo, useCallback } from 'react';

const useAuth = () => {
    const session = useSession();

    const handleLogout = useCallback(() => {
        signOut();
    }, []);

    return useMemo(() => {
        const isAuthenticated = Boolean(session.data?.accessToken);
        const isAdmin = session.data?.user?.role === Roles.ADMIN;

        return {
            user: session.data?.user,
            update: session.update,
            isLoading: session.status === 'loading',
            accessToken: session.data?.accessToken,
            isAuthenticated,
            role: session.data?.user?.role,
            isAdmin,
            logout: handleLogout,
        };
    }, [
        session.data?.accessToken,
        session.data?.user,
        session.update,
        session.status,
        handleLogout,
    ]);
};

export default useAuth;
